"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class CompanyAccountStatusModal extends _react.Component {
  state = {
    status_messages: {},
    warning: undefined,
    loading: false,
    info: undefined
  };
  handleChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  handleOk = e => {
    const component = this,
      props = this.props,
      state = this.state;
    let monitoring_account_status = props.monitoring_account_status || [];
    monitoring_account_status.push({
      status: state.chosen_status
    });
    props.onAccountChange(monitoring_account_status);
    props.onChange({
      value: state.chosen_status,
      name: 'company[current_account_status]'
    }), component.updateAccountStatus();
    component.setState({
      warning: undefined,
      error: undefined
    });
    props.onClose();
  };
  handleClose = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      warning: undefined,
      error: undefined
    });
    if (props.onClose) props.onClose();
  };
  updateAccountStatus = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/company/update-account-status', {
      account_status: state.chosen_status,
      company_id: props.company_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const action_button = /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleOk,
      className: "c-flat-btn",
      color: "primary"
    }, "Mettre \xE0 jour le statut");
    let account_status_options = [{
      label: "Non accepté",
      value: "refused"
    }, {
      label: "En attente",
      value: "waiting"
    }, {
      label: "Accepté",
      value: "accepted"
    }, {
      label: "Désinscrit",
      value: "unsubscribe"
    }];
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open,
      onClose: props.onClose,
      title: "Gestion du suivi du compte entreprise",
      "scroll-area": ".back-page",
      bemit: ['medium', 'simple'],
      "close-label": "FERMER",
      "action-buttons": action_button,
      src: props.trigger_src,
      "close-classes": "c-btn u-margin-right-10"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state.chosen_status,
      name: "chosen_status",
      label: "",
      status: state.status_messages,
      options: account_status_options,
      "default-value": account_status_options[0]?.value
    }))), loader, status);
    return output;
  }
}
var _default = exports.default = CompanyAccountStatusModal;
